import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

/** A CTA for a feature that isn't live yet (payments, apps): tells the user on click. */
export default function SoonButton({ children, className }) {
  const { t } = useTranslation()
  const [shown, setShown] = useState(false)
  useEffect(() => {
    if (!shown) return
    const id = setTimeout(() => setShown(false), 2200)
    return () => clearTimeout(id)
  }, [shown])
  return (
    <button type="button" onClick={() => setShown(true)} className={`cursor-pointer ${className}`} aria-live="polite">
      {shown ? t('common.comingSoon') : children}
    </button>
  )
}
